VjsAdmin.CreateSSOInstance = (ssoTypeId, platformId, districtGuid, districtGuidDisplay) => (function () {
    const SSO_TYPE_GOOGLE_SAML_ID = '1';
    const SSO_TYPE_GOOGLE_OAUTH_ID = '19';
    const SSO_TYPE_CLEVER_ID = '6';
    const SSO_TYPE_CLASSLINK_ID = '9';
    let selectedSSOTypeId = ssoTypeId;

    const init = () => {
        new CreateSSOController();
    };

    let CreateSSOController = VjsUtility.Controller.extend({
        events: {
            'change #select-sso-type-input': 'selectSSOTypeInput',
            'click #create-sso-instance-button': 'clickCreateSSO',
            'click #auto-generate-button': 'clickAutoGenerateButton',
        },
        selectSSOTypeInput: () => {
            selectedSSOTypeId = $('#select-sso-type-input option:selected').val();
            changeSSOInput(selectedSSOTypeId);
        },
        clickCreateSSO: () => {
            VjsUtility.Popup.init({
                title: 'Create SSO Instance',
                templateUrl: '/assets/templates/platforms/districts/sso-popup-form.html',
                data: { ssoTypeId },
                after() {
                    changeSSOInput(selectedSSOTypeId);
                },
            });
        },
        clickAutoGenerateButton: (e) => {
            const errors = validateForm();

            if (errors) {
                e.stopPropagation();
                return false;
            }

            const params = {
                instanceName: $('#instance-name-input').val(),
                ssoTypeId: selectedSSOTypeId,
                ssoUserId: $('#select-ssoUserId-input option:selected').val(),
                platformId,
                districtGuid,
                districtGuidDisplay,
                tenantId: $('#tenant-id-input').val() ?? null,
                cleverDistrictId: $('#district-clever-id-input').val() ?? null,
                googleExtensions: $('#google-extension-input').val().split('\n').join() ?? null,
                isApi: true,
            };
            const req = new VjsUtility.Request();

            let formComponentIDString = '';
            let districtSsoId = '';
            if (params.cleverDistrictId !== '') {
                formComponentIDString = '#district-clever-id';
                districtSsoId = params.cleverDistrictId;
            } else {
                formComponentIDString = '#district-oneroster-id';
                districtSsoId = params.tenantId;
            }

            req.post(Slim.Router.pathFor('api.platforms.districts.sso.auto.generate'), params)
                .done((res) => {
                    $('#sso-instance-guid').val(res.data.ssoInstanceGuid);
                    $(formComponentIDString).val(districtSsoId);
                    VjsUtility.Notification.success({
                        text: 'SSO Instance Created Successfully. SSO Instance Guid added to form.',
                        time: 5000,
                    });
                    VjsUtility.Popup.close();
                })
                .fail((x) => {
                    const error = JSON.parse(x.responseText);
                    let errorText = '';
                    try {
                        errorText = JSON.parse(error.title);
                        errorText = errorText.data;
                    } catch (ee) {
                        errorText = error.title;
                    }
                    VjsUtility.Notification.error({
                        text: errorText,
                        time: 5000,
                    });
                })
                .always(() => {});
        },
    });

    let changeSSOInput = (newSSOTypeId) => {
        switch (newSSOTypeId) {
            case SSO_TYPE_GOOGLE_SAML_ID:
                $('#google-input-group').hide();
                $('#classlink-input-group').hide();
                $('#cleversync-input-group').hide();
                break;
            case SSO_TYPE_GOOGLE_OAUTH_ID:
                $('#google-input-group').show();
                $('#classlink-input-group').hide();
                $('#cleversync-input-group').hide();
                break;
            case SSO_TYPE_CLEVER_ID:
                $('#cleversync-input-group').show();
                $('#classlink-input-group').hide();
                $('#google-input-group').hide();
                break;
            case SSO_TYPE_CLASSLINK_ID:
                $('#classlink-input-group').show();
                $('#cleversync-input-group').hide();
                $('#google-input-group').hide();
                break;
            default:
                break;
        }
        $(`#select-sso-type-input option[value="${newSSOTypeId}"]`).attr('selected', 'selected');
        $(`#select-ssoUserId-input option[data-ssoTypeId="${newSSOTypeId}"]`).attr('selected', 'selected');
    };

    let validateForm = () => {
        let errors = false;
        // All SSO Types
        if ($('#instance-name-input').val() === '' || /\s/.test($('#instance-name-input').val())) {
            $('#instance-name-input').removeClass('is-valid').addClass('is-invalid');
            errors = true;
        } else {
            $('#instance-name-input').removeClass('is-invalid').addClass('is-valid');
        }
        // Google - OAuth
        if ($('#google-extension-input').val() === '' && selectedSSOTypeId === SSO_TYPE_GOOGLE_OAUTH_ID) {
            $('#google-extension-input').removeClass('is-valid').addClass('is-invalid');
            errors = true;
        } else if (selectedSSOTypeId === SSO_TYPE_GOOGLE_OAUTH_ID) {
            let extensions = [];
            $('#google-extension-input')
                .val()
                .split(/\r?\n?\s/)
                .forEach((element) => {
                    extensions.push(element.toLowerCase().match(/@+[a-z0-9]+.+[a-z]/));
                });
            extensions = extensions.flat().filter((ext) => ext != null);
            // if the array is empty, no valid entries were provided
            if (!Array.isArray(extensions) || !extensions.length) {
                $('#google-extension-input').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#google-extension-input').removeClass('is-invalid').addClass('is-valid');
                $('#google-extension-input').val(extensions.join('\n'));
            }
        }
        // Classlink
        if ($('#tenant-id-input').val() === '' && selectedSSOTypeId === SSO_TYPE_CLASSLINK_ID) {
            $('#tenant-id-input').removeClass('is-valid').addClass('is-invalid');
            errors = true;
        } else {
            $('#tenant-id-input').removeClass('is-invalid').addClass('is-valid');
        }
        // Clever
        if ($('#district-clever-id-input').val() === '' && selectedSSOTypeId === SSO_TYPE_CLEVER_ID) {
            $('#district-clever-id-input').removeClass('is-valid').addClass('is-invalid');
            errors = true;
        } else {
            $('#district-clever-id-input').removeClass('is-invalid').addClass('is-valid');
        }

        return errors;
    };

    return {
        init,
    };
}());
